/** @jsx jsx */
import { Themed, jsx } from "theme-ui"

const Footer = () => (
  <footer
    sx={{ pt: 2, my: 4, color: `secondary`, borderTopColor: `muted`, borderTopStyle: `solid`, borderTopWidth: `1px` }}
  >
    <Themed.p>

    </Themed.p>
  </footer>
)

export default Footer
